export default "__VITE_ASSET__6Uz6pMs5__"